export function messagesPath(schoolId?: number | null) {
  if (schoolId) return `/admin/${schoolId}/messages-legacy`
  return '/messages'
}
